import { formatPrice } from '../../utils/index.js'
import { useAiuiContext } from '../../../AiuiProvider/index.js'
import { Text } from '../../../../components/index.js'
import { cn } from '../../../../helpers/index.js'
import { ShippingMethodMode } from './type.js'

const ShippingMethod = ({
  item,
  index,
  active,
  toggleShipping,
  currencyCode,
  metafields,
  className = '',
}: {
  item: any
  index: number
  active: boolean
  toggleShipping: (item: any, index: number) => void
  currencyCode: string
  metafields: any
  className?: string
}) => {
  const { copyWriting, locale = 'us' } = useAiuiContext()

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          toggleShipping(item, index)
        }
      }}
      className={cn(
        'relative flex cursor-pointer  justify-between gap-[16px] desktop:gap-3 lg-desktop:gap-5 overflow-hidden rounded-box border-2 border-[#E8E8E8] px-4 text-[#1F2021]',
        {
          'cursor-not-allowed opacity-60': item.disabled,
          'border-brand': active,
        },
        className
      )}
      onClick={() => toggleShipping(item, index)}
    >
      <div className="relative flex flex-col justify-center">
        <Text
          className={cn('laptop:text-[16px] lg-desktop:text-[18px] text-[14px] font-bold leading-[1.4]', {})}
          as="p"
          html={item.title}
        />
        <Text
          className={cn('laptop:text-[14px] lg-desktop:mt-1 text-[12px] font-bold leading-[1.4] text-[#6D6D6F]', {})}
          as="p"
          html={item.subtitle}
        />
      </div>

      <Text
        className={cn('relative my-auto h-fit text-[18px] desktop:text-xl lg-desktop:text-2xl font-bold', {})}
        as="p"
        html={
          item.price
            ? formatPrice({
                amount: item.price,
                currencyCode,
                locale,
                removeTrailingZeros: true,
              })
            : copyWriting?.free
        }
      />
      {item.mode !== ShippingMethodMode.FREE && (
        <div
          className={cn(
            'bg-brand-0 absolute -right-px -top-px rounded-bl-[8px] rounded-tr-[8px] overflow-hidden px-[8px] py-[2px] desktop:text-[14px] text-[12px] font-bold leading-[1.4] text-white'
          )}
        >
          {metafields?.memberOnly}
        </div>
      )}
    </div>
  )
}

export default ShippingMethod
